import { render, staticRenderFns } from "./systemNoticePop.vue?vue&type=template&id=39f594aa&scoped=true"
import script from "./systemNoticePop.vue?vue&type=script&setup=true&lang=js"
export * from "./systemNoticePop.vue?vue&type=script&setup=true&lang=js"
import style0 from "./systemNoticePop.vue?vue&type=style&index=0&id=39f594aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f594aa",
  null
  
)

export default component.exports